import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import { colorFormatter } from "../../fomatters/ColorFormatter";
import { createColorCreator, createColorEditor } from "../../editors/ColorEditor";
import _ from "lodash";

/**
 * TABLE SYSTEMCOLORS
 */
function GameTypes() {
  return (
    <Crud
      className="unlock-overflow"
      title="Game Types"
      getUrl={() => "/GameType/GameType_Get"}
      getProcess={(data) => _.sortBy(data, ["description"])}
      // INSERT
      insertUrl={() => "/GameType/GameType_Insert"}
      insertParams={(
        { userId },
        { short, description, allowHookUps, allowBuyPoints, fkColor, bkColor }
      ) => ({
        Short: short,
        Description: description,
        AllowHookUps: allowHookUps,
        AllowBuyPoints: allowBuyPoints,
        FkColor: fkColor || 16777215,
        BkColor: bkColor || 16777215,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={(_, { idGameType }) =>
        `/GameType/GameType_Update?idGameType=${idGameType}`
      }
      updateParams={(
        { userId },
        { short, description, allowHookUps, allowBuyPoints, fkColor, bkColor }
      ) => ({
        Short: short,
        Description: description,
        AllowHookUps: allowHookUps,
        AllowBuyPoints: allowBuyPoints,
        FkColor: fkColor || 16777215,
        BkColor: bkColor || 16777215,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={({ userId }, id) =>
        `/GameType/GameType_Delete?idGameType=${id}&idUser=${userId}`
      }
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idGameType"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Description
      </TableHeaderColumn>
      <TableHeaderColumn dataField="short">Short</TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataFormat={moveFormatter}
        editable={{
          type: "checkbox",
          options: {
            values: "true:false",
          },
        }}
        dataField="allowHookUps"
      >
        Hooks Ups
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataFormat={moveFormatter}
        editable={{
          type: "checkbox",
          options: {
            values: "true:false",
          },
        }}
        dataField="allowBuyPoints"
      >
        Allow Buy Points
      </TableHeaderColumn>
      <TableHeaderColumn
        className="overflow-visible"
        dataAlign="center"
        dataField="bkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Background
      </TableHeaderColumn>
      <TableHeaderColumn
        className="overflow-visible"
        dataAlign="center"
        dataField="fkColor"
        dataFormat={colorFormatter}
        customEditor={{
          getElement: createColorEditor,
        }}
        customInsertEditor={{
          getElement: createColorCreator,
        }}
      >
        Font
      </TableHeaderColumn>
    </Crud>
  );
}

export default GameTypes;
